import React from 'react'
import { Button, UncontrolledTooltip } from 'reactstrap'
import { useHistory } from 'react-router-dom'

export const OrderTrackingIndicator = ({ id, webOrderStatus, orderId, showText, showTooltip }) => {
  const history = useHistory()

  if (!webOrderStatus) return null

  const icon = (
    <i
      id={id}
      className={`fa-solid ${webOrderStatus.icon} fa-xl`}
      style={{ color: webOrderStatus.color }}
    />
  )

  return (
    <div className="text-center">
      {orderId ? (
        <Button
          className="p-0"
          color="link"
          onClick={() => history.push(`/orderdetails/${orderId}`)}
        >
          {icon}
        </Button>
      ) : (
        icon
      )}
      <span className="ml-2">{showText ? webOrderStatus.name : null}</span>

      {showTooltip ? (
        <UncontrolledTooltip
          placement="right"
          target={id}
          style={{ maxWidth: '100%', textAlign: 'left' }}
        >
          Estado del pedido: {webOrderStatus.name}
        </UncontrolledTooltip>
      ) : null}
    </div>
  )
}
